import { render, staticRenderFns } from "./ProgramAdminInvite.vue?vue&type=template&id=587a913a&"
import script from "./ProgramAdminInvite.vue?vue&type=script&lang=js&"
export * from "./ProgramAdminInvite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports